import { ISliderIndents } from '../../../../../../../../../common/Slider';
import { DESKTOP_SLIDER_INDENTS, DESKTOP_SLIDER_WITH_BET_POSITION_INDENTS, MOBILE_SLIDER_INDENTS } from './constants';

interface IParams {
  isMobile: boolean;
  isBetPositionVisible: boolean;
}

export const getSliderIndents = ({ isMobile, isBetPositionVisible }: IParams): ISliderIndents => {
  if (isMobile) {
    return MOBILE_SLIDER_INDENTS;
  }

  return isBetPositionVisible ? DESKTOP_SLIDER_INDENTS : DESKTOP_SLIDER_WITH_BET_POSITION_INDENTS;
};
